export const FilterCloseMixin = {

    methods:{
        closeDropDown() {
            $(".dropdown-menu").removeClass('show');
        }
    }

}
